import axios from "./axios-auth";

const getCategories = (params) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getcategories",
      params: params,
      method: "GET",
    })
      .then((resp) => {
        console.log(resp, " from get categories api");
        resolve(resp.data);
      })
      .catch((err) => {
        console.log(err, "error from get categories api");
      });
  });

export { getCategories };
